import React from 'react'
import Header from '../Integration/DashboardHeader'
import SideBarMenu from '../Integration/DashboardSideBarMenu'
import FormUpdateProd from '../Integration/FormUpdateProd'

function DashboardUpdateProduto() {
  return (
    <div>
        

      <div className="homeheader">
        <Header/>

      </div>

     <div className="homebody">



      <div className="homeleft">

      <SideBarMenu/>

      </div>
      <div className="homeright">

        <div className="upright">

          <label></label>
        </div>
        <div className="downright">
            <FormUpdateProd />
        </div>
        <div className='footageright'>

        </div>

      </div>
     </div>
        



    </div>
  )
}

export default DashboardUpdateProduto